export default __webpack_public_path__ + "static/media/kitchen3-afterE-768w.fda0f7ba.png";